import { TFunction } from 'i18next';
import { Sort } from 'shared/assets/icons';
import { FilterGroup, FilterOptionType } from 'shared/types/filter';
import { DocumentOrganizationKeys } from 'shared/types/filter-document';
import { GroupByMode, SortingMode } from 'shared/types/sorting-mode';

export type Options = {
  t: TFunction;
};

export const createGroupingAndSorting = ({ t }: Options): FilterGroup[] => [
  {
    id: 'groupingAndSorting',
    title: t('context-menus.filtering.task.grouping-and-sorting.title'),
    filters: [
      // Sorting
      {
        id: DocumentOrganizationKeys.SortingMode,
        label: t(
          'context-menus.filtering.task.grouping-and-sorting.sort.label',
        ),
        placeholder: t('general.labels.select'),
        icon: Sort,
        type: FilterOptionType.Select,
        selectOptions: [
          {
            label: t(
              `context-menus.filtering.task.grouping-and-sorting.sort.options.${SortingMode.Custom}`,
            ),
            value: SortingMode.Custom,
          },
          {
            label: t(
              `context-menus.filtering.task.grouping-and-sorting.sort.options.${SortingMode.DueDate}`,
            ),
            value: SortingMode.DueDate,
          },
          {
            label: t(
              `context-menus.filtering.task.grouping-and-sorting.sort.options.${SortingMode.Priority}`,
            ),
            value: SortingMode.Priority,
          },
        ],
      },
      // Grouping
      {
        id: DocumentOrganizationKeys.GroupByMode,
        label: t(
          'context-menus.filtering.task.grouping-and-sorting.grouping.label',
        ),
        placeholder: t('general.labels.select'),
        icon: Sort,
        type: FilterOptionType.Select,
        selectOptions: [
          {
            label: t(
              `context-menus.filtering.task.grouping-and-sorting.grouping.options.${GroupByMode.None}`,
            ),
            value: GroupByMode.None,
          },
          {
            label: t(
              `context-menus.filtering.task.grouping-and-sorting.grouping.options.${GroupByMode.LifeArea}`,
            ),
            value: GroupByMode.LifeArea,
          },
          {
            label: t(
              `context-menus.filtering.task.grouping-and-sorting.grouping.options.${GroupByMode.Goal}`,
            ),
            value: GroupByMode.Goal,
          },
          {
            label: t(
              `context-menus.filtering.task.grouping-and-sorting.grouping.options.${GroupByMode.Tag}`,
            ),
            value: GroupByMode.Tag,
          },
          {
            label: t(
              `context-menus.filtering.task.grouping-and-sorting.grouping.options.${GroupByMode.DayPart}`,
            ),
            value: GroupByMode.DayPart,
          },
          {
            label: t(
              `context-menus.filtering.task.grouping-and-sorting.grouping.options.${GroupByMode.Priority}`,
            ),
            value: GroupByMode.Priority,
          },
          {
            label: t(
              `context-menus.filtering.task.grouping-and-sorting.grouping.options.${GroupByMode.Deadline}`,
            ),
            value: GroupByMode.Deadline,
          },
          {
            label: t(
              `context-menus.filtering.task.grouping-and-sorting.grouping.options.${GroupByMode.Type}`,
            ),
            value: GroupByMode.Type,
          },
        ],
      },
    ],
  },
];
